import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  ISmartChargingDeviceCount,
  ISmartChargingEligibility,
} from "./smartChargingEligibility.types"
import { GetSmartChargingEligibilityChecksQuery } from "@/api/hasura/generated/graphql"

export type SmartChargingEligibilityRaw = GetSmartChargingEligibilityChecksQuery

const countByLabel = (
  names: (string | null | undefined)[],
  emptyLabel: string,
) => {
  const counts = new Map<string, number>()
  for (const name of names) {
    const label = name?.trim() || emptyLabel
    counts.set(label, (counts.get(label) ?? 0) + 1)
  }
  return [...counts.entries()]
    .map(([label, count]): ISmartChargingDeviceCount => ({ label, count }))
    .sort((a, b) => b.count - a.count)
}

export const SmartChargingEligibilityParser: IParser<
  ISmartChargingEligibility,
  SmartChargingEligibilityRaw
> = {
  // Rows are already deduplicated to the latest check per billing account by the query.
  toDomain: (data: SmartChargingEligibilityRaw): ISmartChargingEligibility => {
    try {
      const checks = data.ev_tariff_eligibility_checks
      const compatible = checks.filter(
        (check) => check.is_eligible_for_smart_charging,
      )
      return {
        total: checks.length,
        compatible: compatible.length,
        compatibleAccountIds: compatible.map((check) =>
          Number(check.billing_account_id),
        ),
        chargers: countByLabel(
          checks.map((check) => check.axle_charger_name),
          "No charger",
        ),
        evs: countByLabel(
          checks.map((check) => check.axle_ev_name),
          "No EV",
        ),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
